export const TOGGLE_LOADING_ALL_PUBLIC_VIDEO =
  "VideolistsAll/TOGGLE_LOADING_ALL_PUBLIC_VIDEO";
export const LOAD_ALL_PUBLIC_VIDEO = "VideolistsAll/LOAD_ALL_PUBLIC_VIDEO";
export const SELECT_ALL_PLAYLIST_CLIPS_ID =
  "VideolistsAll/SELECT_ALL_PLAYLIST_CLIPS_ID";
export const PUT_ALL_PUBLIC_VIDEO = "VideolistsAll/PUT_ALL_PUBLIC_VIDEO";
export const SAVE_SORT_VIDEO_PARAMS = "VideolistsAll/SAVE_SORT_VIDEO_PARAMS";

export const DELETE_VIDEOLISTS = "Videolists/DELETE_VIDEOLISTS";
export const DELETE_VIDEOS_FROM_VIDEOLIST = "Videolists/DELETE_VIDEOS_FROM_VIDEOLIST";

export const LOAD_VIDEOLISTS = "Videolists/LOAD_VIDEOLISTS";
export const LOAD_VIDEOLIST = "Videolists/LOAD_VIDEOLIST";
export const UPDATE_VIDEOLIST = "Videolists/UPDATE_VIDEOLIST";
export const LOADING = "Videolists/LOADING";
export const PUT_VIDEOLISTS = "Videolists/PUT_VIDEOLISTS";
export const SET_CURRENT_VIDEOLIST = "Videolists/SET_CURRENT_VIDEOLIST";
export const TOGGLE_SELECTED_VIDEOLIST = "Videolists/TOGGLE_SELECTED_VIDEOLIST";
export const TOGGLE_SELECTED_VIDEO = "Videolists/TOGGLE_SELECTED_VIDEO";
export const ADD_VIDEO_TO_LIST = "Videolists/ADD_VIDEO_TO_LIST";
export const ADD_VIDEOS_TO_LISTS = "Videolists/ADD_VIDEOS_TO_LISTS";
export const DOWNLOAD_VIDEOS = "Videolists/DOWNLOAD_VIDEOS";
export const SORT_VIDEOLISTS = "Videolists/SORT_VIDEOLISTS";
export const SORT_VIDEOS = "Videolists/SORT_VIDEOS";
export const SORT_VIDEOS_CURRENT = "Videolists/SORT_VIDEOS_CURRENT";
export const UPDATE_VIDEOS_POSITIONS = "Videolists/SORT_VIDEOS_POSITIONS";
export const OPEN_ADDITIONAL_MENU = "Videolists/OPEN_ADDITIONAL_MENU";
export const CLOSE_ADDITIONAL_MENU = "Videolists/CLOSE_ADDITIONAL_MENU";
export const PUT_SONGS = "Videolists/PUT_SONGS";

export const updateVideosPositions = (payload) => ({
  type: UPDATE_VIDEOS_POSITIONS,
  payload,
});

export const toggleAllPublicVideos_loading = (payload) => ({
  type: TOGGLE_LOADING_ALL_PUBLIC_VIDEO,
  payload,
});

export const selectAllPlaylistClipsId = () => ({
  type: SELECT_ALL_PLAYLIST_CLIPS_ID,
});

export const saveSortVideoParams = (payload) => ({
  type: SAVE_SORT_VIDEO_PARAMS,
  payload,
});

export const sortPublicVideo = (payload) => ({
  type: PUT_ALL_PUBLIC_VIDEO,
  payload,
});

export const sortVideos = (sortSource) => ({
  type: SORT_VIDEOS,
  payload: sortSource,
});

export const sortVideosCurrent = (payload) => ({
  type: SORT_VIDEOS_CURRENT,
  payload,
});

export const putAllPublicVideo = (payload) => ({
  type: PUT_ALL_PUBLIC_VIDEO,
  payload,
});

export const loadAllPublicVideo = (payload) => ({
  type: LOAD_ALL_PUBLIC_VIDEO,
  payload,
});

export const loadVideolists = (payload) => ({
  type: LOAD_VIDEOLISTS,
  payload,
});

export const loadVideolist = (id) => ({
  type: LOAD_VIDEOLIST,
  payload: id,
});

export const updateVideolist = (payload) => ({
  type: UPDATE_VIDEOLIST,
  payload,
});

export const setCurrentVideolist = (videolist) => ({
  type: SET_CURRENT_VIDEOLIST,
  payload: videolist,
});

export const loading = (mode) => ({
  type: LOADING,
  payload: mode,
});

export const deleteVideolists = (selectedVideolists) => ({
  type: DELETE_VIDEOLISTS,
  payload: selectedVideolists,
});
export const deleteVideosFromVideoList = payload => ({
  type: DELETE_VIDEOS_FROM_VIDEOLIST,
  payload
});
export const putVideolists = (videolists) => ({
  type: PUT_VIDEOLISTS,
  payload: videolists,
});

export const toggleSelectedVideolist = ({
  id,
  selected,
  simple,
  required,
}) => ({
  type: TOGGLE_SELECTED_VIDEOLIST,
  payload: {
    id,
    selected,
    simple,
    required,
  },
});
export const toggleSelectedVideo = ({
  id_video,
  selected_video,
  onlyOne,
  setAll,
}) => ({
  type: TOGGLE_SELECTED_VIDEO,
  payload: {
    id_video,
    selected_video,
    setAll,
    onlyOne,
  },
});
export const addVideoToList = ({ id_videolist, selected_song, songs }) => ({
  type: ADD_VIDEO_TO_LIST,
  payload: {
    id_videolist,
    selected_song,
    songs,
  },
});
export const addVideosToLists = (payload) => ({
  type: ADD_VIDEOS_TO_LISTS,
  payload,
});
export const downloadVideos = ({ videosIds }) => ({
  type: DOWNLOAD_VIDEOS,
  payload: {
    videosIds,
  },
});
export const sortVideolists = (sortSource) => ({
  type: SORT_VIDEOLISTS,
  payload: sortSource,
});
export const openAdditionalMenu = payload => ({
  type: OPEN_ADDITIONAL_MENU,
  payload,
});
export const closeAdditionalMenu = payload => ({
  type: CLOSE_ADDITIONAL_MENU,
  payload,
});
export const putSongs = payload => ({
  type: PUT_SONGS,
  payload,
});